// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 诺诺配置表单项
 * @constructor
 */
const NuoNuoFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "appKey"]}
        label={"AppKey"}
        placeholder={"请输入appKey"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入appKey"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "appSecret"]}
        label={"AppSecret"}
        placeholder={"请输入appSecret"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入appSecret"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "tokenType"]}
        label={"tokenType"}
        placeholder={"token类型，为true代表长期有效，为false为自行获取"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入tokenType"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "token"]}
        label={"token"}
        placeholder={"请输入token"}
        width={"lg"}
        rules={[
          {
            required: false,
            message: "请输入token"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default NuoNuoFormItems
